import { MainContainer } from '@/components/atoms'
import { Layout } from '@/components/templates'
import { Button, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { PriceFeedsList } from '../organisms'
import { useQuery } from '@tanstack/react-query'
import { getPriceFeeds } from '@/actions'

const priceFeedsLimit = 4

export const Home = () => {
  const { data: priceFeeds, isLoading } = useQuery({
    queryKey: ['price-feeds'],
    queryFn: () => getPriceFeeds(),
    select: (data) => {
      return data ? data.slice(0, priceFeedsLimit) : []
    },
  })

  return (
    <Layout>
      <MainContainer>
        <VStack textAlign={'center'} maxW={600} m={'auto'} mb={8}>
          <Heading>Decentralized Price feeds for smart contracts</Heading>
          <Text>
            Erinaceus Price Feeds offer a secure, reliable, and decentralized
            source of off-chain data to enable unique smart contract
            applications in DeFi and beyond.
          </Text>
        </VStack>

        <VStack gap={10} alignItems={'center'} justifyContent={'center'}>
          <Button as={Link} to={'/launch'} variant={'soft'}>
            Launch Your Price Feed
          </Button>

          <VStack w={'full'} gap={0} alignItems={'stretch'}>
            <HStack
              gap={[4, 6]}
              flexDirection={['column', 'row']}
              alignItems={'center'}
              mb={4}
            >
              <Heading size={'lg'}>Available Price Feeds</Heading>

              <Button variant={'outline'} as={Link} to={'/price-feeds'}>
                Show All
              </Button>
            </HStack>

            <PriceFeedsList
              isLoading={!priceFeeds || isLoading}
              items={priceFeeds}
            />
          </VStack>
        </VStack>
      </MainContainer>
    </Layout>
  )
}
